import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastMessageOptions } from 'primeng/api/toastmessage';

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    private messageService= inject(MessageService);

    public info(options: ToastMessageOptions) {
        this.messageService.add({
            summary: 'Info',
            ...options,
            severity: 'info',
            life: 7500,
        });
    }

    public success(options: ToastMessageOptions) {
        this.messageService.add({
            summary: 'Success',
            ...options,
            severity: 'success',
            life: 7500,
        });
    }

    public warn(options: ToastMessageOptions) {
        this.messageService.add({
            summary: 'Warning',
            ...options,
            severity: 'warn',
            life: 7500,
        });
    }

    public error(options: ToastMessageOptions) {
        this.messageService.add({
            summary: 'Error',
            ...options,
            severity: 'error',
            life: 7500,
        });
    }

}
